export default __webpack_public_path__ + "static/media/more-end-game.3a3e34ba.md";